export abstract class DataReader<T> {
    public abstract read(data: Uint8Array): T;
}